import { ConferenceBoothCreationPage } from '@/components/admin/events/conference-booth-page/ConferenceBoothCreationPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(ConferenceBoothCreationPage, {
  requiresEvery: [
    RouteRestrictions.ADMIN_ROLE,
    RouteRestrictions.FEATURE_FLAG_CONFERENCES,
  ],
});
